import { modalType } from '../../util/ModalUtil';
import { useDispatch } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import CodeUtil from '../../util/CodeUtil';
import { CODE_GROUP_ID } from '../../constant/Constant';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import SelectionBox from '../../component/SelectionBox';
import InputBox from '../../component/InputBox';
import {
    actionStaffByUniversityAdd,
    actionStaffByUniversityEdit,
    actionStaffByUniversityPwreset,
} from '../../module/body/system/SystemUniversityManagerModule';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import PopupRef from '../../component/PopupRef';
import TelNoInputBox from '../../component/TelNoInputBox';
import NullCheckUtil from '../../util/NullCheckUtil';

const SystemUniversityModal = ({ type, modalRef, row, callback }) => {
    const dispatch = useDispatch();
    const popupRef = useRef(null);

    const [userUniversityCd, setUserUniversityCd] = useState();
    const [userId, setUserId] = useState();
    const [userNm, setUserNm] = useState();
    const [email, setEmail] = useState();
    const [telNo, setTelNo] = useState();

    useEffect(() => {
        if (type == modalType.ADD) {
            setUserUniversityCd(CodeUtil.getFirstCode(CODE_GROUP_ID.USER_UNIVERSITY));
        } else {
            row && setUserUniversityCd(row.userUniversityCd);
            row && setUserId(row.userId);
            row && setUserNm(row.userNm);
            row && setEmail(row.email);
            row && setTelNo(row.telNo);
        }
    }, []);

    const handleCancel = () => {
        modalRef.current.close();
    };

    const handleConfirm = () => {
        if (validateStaff()) {
            type == modalType.ADD
                ? dispatch(
                      actionStaffByUniversityAdd({
                          data: {
                              userUniversityCd,
                              userId,
                              userNm,
                              email,
                              telNo,
                          },
                          callback: (params) => {
                              popupRef.current.openInfo(
                                  '참여대학 담당자 ' +
                                      params.userNm +
                                      '의 정보가 등록되었습니다. ' +
                                      params.email +
                                      '로 인증 메일이 발송되었습니다. 인증 메일을 통해 비밀번호를 변경해주세요.',
                                  () => {
                                      return function () {
                                          modalRef.current.close();
                                      };
                                  },
                              );
                              callback();
                          },
                      }),
                  )
                : dispatch(
                      actionStaffByUniversityEdit({
                          data: { userUniversityCd, userId, userNm, email, telNo },
                          callback: () => {
                              popupRef.current.openInfo(
                                  '참여대학 담당자 ' + userNm + '의 정보가 수정되었습니다.',
                                  () => {
                                      return function () {
                                          modalRef.current.close();
                                      };
                                  },
                              );
                              callback();
                          },
                      }),
                  );
        }
    };

    const validateStaff = () => {
        if (NullCheckUtil.isEmpty(userUniversityCd)) {
            popupRef.current.openAlert('참여대학교를 선택해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(userId)) {
            popupRef.current.openAlert('담당자ID를 입력해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(userNm)) {
            popupRef.current.openAlert('담당자명을 입력해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(email)) {
            popupRef.current.openAlert('이메일을 입력해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(telNo)) {
            popupRef.current.openAlert('담당자 연락처를 입력해주세요.');
            return false;
        }

        return true;
    };

    const sendPasswordResetMail = (e) => {
        dispatch(
            actionStaffByUniversityPwreset({
                data: { userUniversityCd, userId, userNm, email, telNo },
                callback: () => {
                    popupRef.current.openInfo(email + '로 인증 메일이 발송되었습니다.');
                },
            }),
        );
    };

    // 타이틀 관련 수정 명확하도록 외부 변수로 처리 필요
    return (
        <>
            <ModalHeader
                title={type == modalType.ADD ? '참여대학 담당자 등록' : '참여대학 담당자 수정'}
                modalRef={modalRef}
            />
            <div className='modal-body'>
                <div className='con-inner SystemUniversityModal'>
                    <InfoTxt
                        infoTxt={
                            type == modalType.ADD
                                ? '참여대학 담당자 정보를 등록합니다.'
                                : '참여대학 담당자 정보를 수정합니다. 인증 메일(24시간 유효) 재발송이 가능합니다.'
                        }
                    />
                    <div>
                        <div className='form-box-row'>
                            <InputBox
                                title='담당자ID'
                                value={userId}
                                disabled={type == modalType.EDIT}
                                onChange={(e) => setUserId(e.target.value)}
                            />
                            {type == modalType.EDIT && (
                                <button
                                    type='button'
                                    className='btn blue-border'
                                    style={{ width: '200px' }}
                                    onClick={(e) => sendPasswordResetMail(e)}
                                >
                                    {'인증메일 재발송'}
                                </button>
                            )}
                        </div>
                        <div className='form-box-row'>
                            <SelectionBox
                                title='참여대학'
                                options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                value={userUniversityCd}
                                onChange={(e) => setUserUniversityCd(e.target.value)}
                                useAll={false}
                            />
                            <InputBox title='담당자명' value={userNm} onChange={(e) => setUserNm(e.target.value)} />
                        </div>
                        <div className='form-box-row'>
                            <InputBox title='이메일' value={email} onChange={(e) => setEmail(e.target.value)} />
                            {/* <InputBox title='담당자 연락처' value={telNo} onChange={(e) => setTelNo(e.target.value)} /> */}
                            <TelNoInputBox title='담당자 연락처' value={telNo} setTelNo={setTelNo} />
                        </div>
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default SystemUniversityModal;
